import introScreen from "./intro_screen.json";
import introTapToStart from "./intro_tap_to_start.json";
import lines from "./lines.json";
import miniPaytable from "./mini_paytable.json";
import winText from "./win_text.json";
import winCelebration from "./win_celebration.json";
import winCounter from "./win_counter.json";
import winCelebrationCounter from "./win_celebration_counter.json";
import jackpots from "./jackpots.json";
import coinValue from "./coin_value.json";


export const FONT_STYLES = {
  introScreen,
  introTapToStart,
  lines,
  miniPaytable,
  winText,
  winCelebration,
  winCounter,
  winCelebrationCounter,
  jackpots,
  coinValue,

};

/**
 * Scale a font style to a new fontSize while keeping pixel-based properties proportional.
 * Takes the JSON style as the "reference" design and scales dropShadowDistance and
 * strokeThickness proportionally to the ratio (newFontSize / originalFontSize).
 *
 * Usage:
 *   const style = scaleStyle(FONT_STYLES.introScreen, 24);
 *   const pixiStyle = new PIXI.TextStyle(style);
 *
 * If no fontSize override is provided, returns the original style unchanged.
 *
 * @param {Object} baseStyle - The reference font style from JSON
 * @param {number} [fontSizeOverride] - Desired fontSize (omit to use original)
 * @param {Object} [extraProps] - Additional PIXI.TextStyle properties to merge (e.g., wordWrap)
 * @returns {Object} New style object with proportionally scaled properties
 */
export const scaleStyle = (baseStyle, fontSizeOverride, extraProps) => {
  const originalFontSize = baseStyle.fontSize;
  const fontSize = fontSizeOverride || originalFontSize;
  const ratio = fontSize / originalFontSize;

  return {
    ...baseStyle,
    fontSize,
    // Scale pixel-based properties proportionally
    ...(baseStyle.dropShadowDistance != null && {
      dropShadowDistance: Math.round(baseStyle.dropShadowDistance * ratio),
    }),
    ...(baseStyle.strokeThickness != null && {
      strokeThickness: Math.round(baseStyle.strokeThickness * ratio) || 1,
    }),
    ...(baseStyle.dropShadowBlur != null && {
      dropShadowBlur: Math.round(baseStyle.dropShadowBlur * ratio),
    }),
    ...extraProps,
  };
};
